/* eslint max-len: 0 */
import React, { SVGProps } from "react";

import { useIconIdPrefix } from "~/components/Icons/utils/useIconIdPrefix";

const PhoneCircle = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const prefix = useIconIdPrefix("PhoneCircle");

  return (
    <svg
      width="82px"
      height="82px"
      viewBox="0 0 82 82"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--fill-phone-circle"
      {...props}
    >
      <defs>
        <circle id={`${prefix}-path-1`} cx="30" cy="30" r="30" />
        <filter
          id={`${prefix}-filter-2`}
          x="-27.5%"
          y="-27.5%"
          width="155.0%"
          height="155.0%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="5.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0786986451 0"
            type="matrix"
            in="shadowBlurOuter1"
          />
        </filter>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-659.000000, -343.000000)">
          <g transform="translate(670.000000, 354.000000)">
            <g>
              <use fill="black" fillOpacity="1" filter={`url(#${prefix}-filter-2)`} xlinkHref={`#${prefix}-path-1`} />
              <circle
                stroke="#76CEDE"
                strokeWidth="1"
                strokeLinejoin="miter"
                fill="#FFFFFF"
                fillRule="evenodd"
                cx="30"
                cy="30"
                r="29.5"
              />
            </g>
            <path
              d="M21.3749955,40.499994 C24.6562377,40.499994 27.7031054,39.6796835 30.5155987,38.0390624 C33.2499672,36.4244831 35.4244414,34.2500089 37.0390207,31.5156405 C38.6796418,28.7031472 39.4999523,25.6562794 39.4999523,22.3750373 C39.4999523,22.1667046 39.4348481,21.9713926 39.3046403,21.7891011 C39.1744325,21.6068097 38.992141,21.5026437 38.7577666,21.4766019 L38.7577666,21.4766019 L34.6952763,20.5391041 C34.4869436,20.4870211 34.2786104,20.5130626 34.0702778,20.6172289 C33.8619451,20.7213956 33.7187161,20.8776452 33.6405913,21.0859778 L33.6405913,21.0859778 L31.7655958,25.4609674 C31.6874709,25.6432588 31.6744503,25.8320603 31.7265333,26.0273723 C31.7786164,26.2226843 31.882783,26.3984652 32.0390326,26.5547148 L32.0390326,26.5547148 L34.382777,28.4687727 C33.6796537,29.979186 32.7356453,31.333349 31.5507525,32.531263 C30.3658597,33.729177 29.0051855,34.6796954 27.468731,35.3828187 L27.468731,35.3828187 L25.5546731,33.0390743 C25.3984234,32.8828247 25.2226426,32.7786581 25.0273306,32.7265751 C24.8320185,32.6744921 24.6432171,32.6875127 24.4609257,32.7656375 L24.4609257,32.7656375 L20.0859361,34.640633 C19.8776035,34.7187578 19.7213538,34.8619868 19.6171872,35.0703195 C19.5130208,35.2786521 19.4869794,35.4869854 19.5390624,35.695318 L19.5390624,35.695318 L20.4765602,39.7578083 C20.502602,39.9921828 20.606768,40.1744742 20.7890594,40.304682 C20.9713509,40.4348898 21.1666629,40.499994 21.3749955,40.499994 Z M21.3749955,40.499994 C24.6562377,40.499994 27.7031054,39.6796835 30.5155987,38.0390624 C33.2499672,36.4244831 35.4244414,34.2500089 37.0390207,31.5156405 C38.6796418,28.7031472 39.4999523,25.6562794 39.4999523,22.3750373 C39.4999523,22.1667046 39.4348481,21.9713926 39.3046403,21.7891011 C39.1744325,21.6068097 38.992141,21.5026437 38.7577666,21.4766019 L38.7577666,21.4766019 L34.6952763,20.5391041 C34.4869436,20.4870211 34.2786104,20.5130626 34.0702778,20.6172289 C33.8619451,20.7213956 33.7187161,20.8776452 33.6405913,21.0859778 L33.6405913,21.0859778 L31.7655958,25.4609674 C31.6874709,25.6432588 31.6744503,25.8320603 31.7265333,26.0273723 C31.7786164,26.2226843 31.882783,26.3984652 32.0390326,26.5547148 L32.0390326,26.5547148 L34.382777,28.4687727 C33.6796537,29.979186 32.7356453,31.333349 31.5507525,32.531263 C30.3658597,33.729177 29.0051855,34.6796954 27.468731,35.3828187 L27.468731,35.3828187 L25.5546731,33.0390743 C25.3984234,32.8828247 25.2226426,32.7786581 25.0273306,32.7265751 C24.8320185,32.6744921 24.6432171,32.6875127 24.4609257,32.7656375 L24.4609257,32.7656375 L20.0859361,34.640633 C19.8776035,34.7187578 19.7213538,34.8619868 19.6171872,35.0703195 C19.5130208,35.2786521 19.4869794,35.4869854 19.5390624,35.695318 L19.5390624,35.695318 L20.4765602,39.7578083 C20.502602,39.9921828 20.606768,40.1744742 20.7890594,40.304682 C20.9713509,40.4348898 21.1666629,40.499994 21.3749955,40.499994 Z"
              fill="#76CEDE"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

PhoneCircle.displayName = "PhoneCircle";

export default PhoneCircle;
